import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = '/logo.jpg';

const quickLinks = [
  { label: 'Services', href: '/#services' }, { label: 'About Us', href: '/#about' },
  { label: 'Our Process', href: '/#process' }, { label: 'Gallery', href: '/#gallery' },
  { label: 'Blog', href: '/blog' }, { label: 'FAQ', href: '/#faq' }, { label: 'Contact', href: '/#contact' },
];

const services = [
  { label: 'Electrical Troubleshooting', link: '/services/electrical-repair-nashville' },
  { label: 'Panel Replacement', link: '/services/electrical-panel-upgrade-nashville' },
  { label: 'EV Charger Installation', link: '/services/ev-charger-installation-nashville' },
  { label: 'Lighting & Switches', link: '/services/lighting-installation-nashville' },
  { label: 'Pool & Spa Wiring', link: '/services/pool-spa-wiring-nashville' },
];

function FooterBrand() {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <img src={LOGO_URL} alt="Evolution Electric" className="h-24 object-contain" width={96} height={96} />
      </div>
      <p className="font-body text-sm text-white/50 leading-relaxed mb-6">
        Your trusted electrical partner in Nashville. Licensed, insured, and serving Nashville since 2014.
      </p>
      <div className="space-y-2">
        <a href="tel:+16159615930" className="flex items-center gap-2 text-sm text-white/50 hover:text-yellow-400 transition-colors" data-testid="footer-phone">
          <Phone className="w-4 h-4" /> (615) 961-5930
        </a>
        <a href="mailto:support@nashvilleelectricalservice.com" className="flex items-center gap-2 text-sm text-white/50 hover:text-yellow-400 transition-colors" data-testid="footer-email">
          <Mail className="w-4 h-4" /> support@nashvilleelectricalservice.com
        </a>
        <div className="flex items-center gap-2 text-sm text-white/50">
          <MapPin className="w-4 h-4" /> Nashville, TN & Surrounding Counties
        </div>
      </div>
    </div>
  );
}

function FooterLinks() {
  return (
    <div>
      <h4 className="font-heading font-bold text-xs uppercase tracking-widest mb-4 text-white/80">Quick Links</h4>
      <ul className="space-y-2">
        {quickLinks.map(link => (
          <li key={link.href}>
            <a href={link.href} className="font-body text-sm text-white/50 hover:text-yellow-400 transition-colors" data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}>{link.label}</a>
          </li>
        ))}
        <li><a href="/admin" className="font-body text-sm text-white/20 hover:text-yellow-400 transition-colors" data-testid="footer-admin-link">Admin</a></li>
      </ul>
    </div>
  );
}

function FooterServices() {
  return (
    <div>
      <h4 className="font-heading font-bold text-xs uppercase tracking-widest mb-4 text-white/80">Our Services</h4>
      <ul className="space-y-2">
        {services.map(svc => (
          <li key={svc.label}><Link to={svc.link} className="font-body text-sm text-white/50 hover:text-yellow-400 transition-colors">{svc.label}</Link></li>
        ))}
        <li className="pt-2 border-t border-white/10 mt-2">
          <Link to="/services/residential-electrical-services-nashville" className="font-body text-sm text-yellow-400/70 hover:text-yellow-400 transition-colors" data-testid="footer-residential-link">Residential Services</Link>
        </li>
        <li>
          <Link to="/services/commercial-electrical-services-nashville" className="font-body text-sm text-yellow-400/70 hover:text-yellow-400 transition-colors" data-testid="footer-commercial-link">Commercial Services</Link>
        </li>
        <li className="pt-2 border-t border-white/10 mt-2">
          <a href="https://generatorsofnashville.com" className="font-body text-sm text-yellow-400/70 hover:text-yellow-400 transition-colors" data-testid="footer-generators-link">Whole-Home Backup Power — Generators of Nashville</a>
        </li>
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black text-white">
      <div className="border-b border-white/10 py-12 px-6 overflow-hidden">
        <p className="font-display text-[8vw] sm:text-[6vw] lg:text-[4vw] text-white/[0.04] uppercase leading-none text-center whitespace-nowrap select-none">
          EVOLUTION ELECTRIC &bull; NASHVILLE &bull; SINCE 2014
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <FooterBrand />
        <FooterLinks />
        <FooterServices />
      </div>
      <div className="border-t border-white/10 py-6 px-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/30">&copy; {new Date().getFullYear()} Evolution Electric. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="font-body text-xs text-white/30 hover:text-yellow-400 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="font-body text-xs text-white/30 hover:text-yellow-400 transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <p className="font-body text-xs text-white/30">Licensed by State of Tennessee &bull; IBEW Journeyman Experience</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
